import { BaseCommand } from './commands';
import { O2DetailedBarUnbarCommand } from './O2DetailedBarUnbarCommand';

export class O2DetailedUnbarCommand extends O2DetailedBarUnbarCommand {
  public definitionAlias: 'o2-detailed-unbar' = 'o2-detailed-unbar';
  constructor(command: BaseCommand) {
    super(command);
  }
}
